import React from 'react';
import { usePWA } from '../../hooks/usePWA';
import { Download, X, Share } from 'lucide-react';

export default function PWAInstallBanner() {
  const { installPrompt, isInstalled, showIOSHint, install, dismiss, dismissIOSHint } = usePWA();

  // Não mostrar se já instalado
  if (isInstalled) return null;

  if (installPrompt) {
    return (
      <div className="fixed bottom-20 left-4 right-4 z-50 animate-slide-in" data-testid="pwa-install-banner">
        <div className="bg-brand-dark text-white rounded-2xl p-4 shadow-xl flex items-center gap-3">
          <div className="w-10 h-10 bg-brand-accent-light rounded-xl flex items-center justify-center flex-shrink-0">
            <Download className="w-5 h-5 text-brand-dark" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-sm leading-tight">Instalar App</p>
            <p className="text-xs opacity-75 mt-0.5">Acesse mais rápido pela tela inicial</p>
          </div>
          <button
            onClick={install}
            className="bg-brand-primary px-3 py-1.5 rounded-lg text-sm font-semibold whitespace-nowrap flex-shrink-0"
            data-testid="pwa-install-btn"
          >
            Instalar
          </button>
          <button onClick={dismiss} className="p-1 flex-shrink-0 opacity-70 hover:opacity-100" data-testid="pwa-banner-dismiss">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    );
  }

  if (showIOSHint) {
    return (
      <div className="fixed bottom-20 left-4 right-4 z-50 animate-slide-in" data-testid="pwa-ios-hint">
        <div className="bg-brand-dark text-white rounded-2xl p-4 shadow-xl">
          <div className="flex justify-between items-start mb-2">
            <div className="flex items-center gap-2">
              <Share className="w-5 h-5 flex-shrink-0" />
              <p className="font-semibold text-sm">Instale no iPhone</p>
            </div>
            <button onClick={dismissIOSHint} data-testid="pwa-ios-dismiss" className="opacity-70 hover:opacity-100">
              <X className="w-4 h-4" />
            </button>
          </div>
          <p className="text-xs opacity-90 leading-relaxed">
            Toque em <strong>Compartilhar</strong> <Share className="inline w-3 h-3" /> na barra do Safari,
            depois em <strong>"Adicionar à Tela de Início"</strong>
          </p>
        </div>
      </div>
    );
  }

  return null;
}
